import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IEventReportPayload } from '@app-store/slices/reporting/eventReport'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IEventReportPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.reporting.eventReport

function* eventReportSagaTask({ payload }) {
    try {
        // const params: any = {}
        const response = yield axios.get(`/reporting/agendas/event-report?format=${payload.format || 'pdf'}`, {
            responseType: 'blob'
        })
        if (response) {
            yield put(onSuccess(response))
            yield put(payload?.sagaCB?.onSuccess(response))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* eventReportSaga(): any {
    yield takeLatest<TaskAction>(onRequest, eventReportSagaTask)
}

export default eventReportSaga
